// Saved deep analysis viewer (2026-10-23, "צפה בניתוח"). Shows the analysis the backend saved for the Home card's
// workout (utils/deepAnalysis.fetchSavedDeepAnalysis) — the text as saved, newlines kept, nothing regenerated.
import React from 'react';
import { Sparkle } from '@phosphor-icons/react';
import { Button, Skeleton } from '../ui';

function dayMonth(date) {
  const m = /^\d{4}-(\d{2})-(\d{2})/.exec(String(date || ''));
  return m ? `${Number(m[2])}.${Number(m[1])}` : '';
}

export default function DeepAnalysisViewer({ open, loading, text, date, onClose }) {
  if (!open) return null;
  const dm = dayMonth(date);
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm p-4"
      onClick={onClose}
      dir="rtl"
      data-testid="deep-analysis-viewer"
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="deep-analysis-viewer-title"
        className="bg-surface border border-border rounded-card shadow-card max-w-lg w-full max-h-[85vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center gap-2.5 px-5 pt-5 pb-3 border-b border-border">
          <div className="w-9 h-9 rounded-control bg-accent-soft text-accent flex items-center justify-center shrink-0">
            <Sparkle size={18} weight="fill" />
          </div>
          <div className="min-w-0">
            <h2 id="deep-analysis-viewer-title" className="text-text text-lg font-bold m-0">ניתוח העומק</h2>
            {dm && <p className="text-text-muted text-xs m-0 mt-0.5">האימון מ-{dm}</p>}
          </div>
        </div>
        <div className="px-5 py-4 overflow-y-auto text-text-body text-sm leading-relaxed whitespace-pre-wrap break-words"
             data-testid="deep-analysis-text">
          {loading ? <Skeleton className="h-40 w-full" /> : text}
        </div>
        <div className="px-5 pb-5 pt-2">
          <Button variant="secondary" onClick={onClose}>סגור</Button>
        </div>
      </div>
    </div>
  );
}
